// web/src/lib/formatters.ts
// Locale-aware formatting functions driven by user jurisdiction from profile.
export const DEFAULT_LOCALE = "en-US";
export const DEFAULT_CURRENCY = "USD";
const JURISDICTION_MAP = {
    us: { locale: "en-US", currency: "USD" },
    uk: { locale: "en-GB", currency: "GBP" },
    in: { locale: "en-IN", currency: "INR" },
};
export function localeFromJurisdiction(jurisdiction) {
    if (!jurisdiction)
        return { locale: DEFAULT_LOCALE, currency: DEFAULT_CURRENCY };
    return JURISDICTION_MAP[jurisdiction.toLowerCase()] ?? { locale: DEFAULT_LOCALE, currency: DEFAULT_CURRENCY };
}
export function fmtCurrency(value, locale, currency) {
    return new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(value);
}
export function fmtNumber(value, locale) {
    return new Intl.NumberFormat(locale).format(value);
}
export function fmtPercent(value, locale) {
    const sign = value > 0 ? "+" : "";
    return `${sign}${new Intl.NumberFormat(locale, {
        minimumFractionDigits: 1,
        maximumFractionDigits: 2,
    }).format(value)}%`;
}
